import { Grid, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { IoAddCircleOutline } from 'react-icons/io5';

interface ExcludedBoxesListProps {
  excludedBoxes: string[];
  includeBox: (boxId: string) => void;
}

export function ExcludedBoxesList(props: ExcludedBoxesListProps) {
  return (
    <Grid container size={12}>
      <Paper style={{ marginTop: 10, marginBottom: 10, width: '100%' }}>
        <Table>
          <TableHead style={{ textAlign: 'center' }}>
            <TableRow>
              <TableCell>
                <Typography style={{ paddingTop: 5, paddingBottom: 5 }}>Excluded Boxes</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.excludedBoxes.map((boxId) => (
              <TableRow key={boxId}>
                <TableCell>
                  <Grid container direction="row" style={{ display: 'flex', alignItems: 'center' }} size={12}>
                    <IconButton
                      size={'small'}
                      onClick={() => props.includeBox(boxId)}
                      style={{ padding: 6, marginRight: 5 }}
                    >
                      <IoAddCircleOutline />
                    </IconButton>
                    <Typography variant={'body2'}>Box {boxId}</Typography>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Grid>
  );
}
